/* Master theme: cart drawer, AJAX add to cart, variant/pack picker, sale countdown. */
(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const d = drawer.dataset;
  const $ = (sel, root = drawer) => root.querySelector(sel);
  const threshold = parseInt(d.threshold || '0', 10);
  const reserveMinutes = parseInt(d.reserve || '0', 10);
  let appliedViaRedirect = '';

  const money = cents => {
    const f = d.money || '${{amount}}';
    const n = cents / 100;
    let s;
    if (f.includes('amount_no_decimals')) s = Math.round(n).toLocaleString('en');
    else if (f.includes('amount_with_comma_separator')) s = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    else s = n.toLocaleString('en', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    return f.replace(/\{\{\s*amount[^}]*\}\}/, s);
  };
  const esc = s => String(s).replace(/[&<>"']/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));
  const post = (url, body) => fetch(url, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)});

  /* ---------- drawer ---------- */
  const backdrop = document.querySelector('.drawer-backdrop');
  const open = () => {
    drawer.hidden = false; backdrop.hidden = false;
    requestAnimationFrame(() => { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); });
    document.body.style.overflow = 'hidden';
    startReserve();
    $('.drawer-close')?.focus();
  };
  const close = () => {
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(() => { drawer.hidden = true; backdrop.hidden = true; }, 250);
  };
  document.addEventListener('click', e => {
    if (e.target.closest('[data-drawer-close]')) close();
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); refresh().then(open); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

  const render = cart => {
    const items = $('[data-drawer-items]');
    const foot = $('[data-drawer-foot]');
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    $('[data-drawer-count]').textContent = cart.item_count;
    if (!cart.items.length) {
      items.innerHTML = `<p class="muted">${esc(d.tEmpty)}</p>`;
      foot.hidden = true;
    } else {
      items.innerHTML = cart.items.map(it => `
        <div class="drawer-item" data-key="${esc(it.key)}">
          ${it.image ? `<img src="${esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2'))}" alt="" width="80" height="80" loading="lazy">` : '<span class="drawer-thumb"></span>'}
          <div>
            <p class="drawer-title">${esc(it.product_title)}</p>
            ${it.variant_title && it.variant_title !== 'Default Title' ? `<p class="fine muted">${esc(it.variant_title)}</p>` : ''}
            <div class="drawer-qty"><button type="button" data-qty="-1" aria-label="−">−</button><span>${it.quantity}</span><button type="button" data-qty="1" aria-label="+">+</button><button type="button" class="drawer-remove" data-qty="0">${esc(d.tRemove)}</button></div>
          </div>
          <strong>${it.final_line_price < it.original_line_price ? `<s class="fine muted">${money(it.original_line_price)}</s> ` : ''}${money(it.final_line_price)}</strong>
        </div>`).join('');
      foot.hidden = false;
    }
    const disc = $('[data-drawer-discounts]');
    const apps = (cart.cart_level_discount_applications || []).map(a => `<p class="fine">${esc(a.title)} −${money(a.total_allocated_amount)}</p>`).join('');
    disc.innerHTML = apps;
    $('[data-drawer-total]').textContent = money(cart.total_price);
    $('[data-drawer-total-btn]').textContent = money(cart.total_price);
    const codes = (cart.discount_codes || []).filter(c => c.applicable).map(c => c.code);
    const input = $('[data-drawer-discount] input');
    if (codes.length && input && !input.value) { input.value = codes[0]; $('[data-drawer-discount-msg]').textContent = d.tApplied; }
    if (threshold > 0) {
      const left = threshold - cart.total_price;
      const txt = $('[data-drawer-ship-text]'), bar = $('[data-drawer-ship-bar]');
      txt.textContent = left > 0 ? d.tUnlock.replace('{{ amount }}', money(left)) : d.tUnlocked;
      bar.style.width = Math.min(100, Math.round(cart.total_price / threshold * 100)) + '%';
      $('[data-drawer-ship]').classList.toggle('is-done', left <= 0);
    }
  };
  const refresh = () => fetch('/cart.js', {headers: {Accept: 'application/json'}}).then(r => r.json()).then(c => { render(c); return c; });

  drawer.addEventListener('click', e => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const row = b.closest('[data-key]');
    const current = parseInt(row.querySelector('.drawer-qty span').textContent, 10);
    const delta = parseInt(b.dataset.qty, 10);
    const quantity = delta === 0 ? 0 : Math.max(0, current + delta);
    row.style.opacity = '.5';
    post('/cart/change.js', {id: row.dataset.key, quantity}).then(r => r.json()).then(render);
  });

  /* ---------- discount code ---------- */
  $('[data-drawer-discount]')?.addEventListener('submit', async e => {
    e.preventDefault();
    const input = e.target.querySelector('input');
    const msg = $('[data-drawer-discount-msg]');
    const code = input.value.trim().toUpperCase();
    if (!code) return;
    msg.textContent = '…';
    try {
      const r = await post('/cart/update.js', {discount: code});
      const cart = await r.json();
      if (r.ok && Array.isArray(cart.discount_codes)) {
        const ok = cart.discount_codes.some(c => c.code.toUpperCase() === code && c.applicable);
        render(cart);
        msg.textContent = ok ? d.tApplied : d.tInvalid;
        if (ok) $('[data-drawer-checkout]').href = '/checkout';
        return;
      }
      throw new Error('unsupported');
    } catch (_) {
      // Fallback for stores where the Cart API can't apply codes: the code is attached at checkout instead.
      await fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(d.cartUrl), {credentials: 'same-origin'});
      appliedViaRedirect = code;
      $('[data-drawer-checkout]').href = '/checkout?discount=' + encodeURIComponent(code);
      msg.textContent = d.tCheckoutApplied;
    }
  });

  /* ---------- reserve timer ---------- */
  let reserveTimer;
  const startReserve = () => {
    const el = $('[data-drawer-reserve]');
    if (!el || reserveMinutes <= 0 || reserveTimer) return;
    let until = parseInt(sessionStorage.getItem('masterReserveUntil') || '0', 10);
    if (!until || until < Date.now()) { until = Date.now() + reserveMinutes * 60000; sessionStorage.setItem('masterReserveUntil', String(until)); }
    const tick = () => {
      const left = Math.max(0, until - Date.now());
      const m = Math.floor(left / 60000), s = Math.floor(left % 60000 / 1000);
      el.textContent = d.tReserved.replace('{{ time }}', `${m}:${String(s).padStart(2, '0')}`);
      el.hidden = left <= 0;
      if (left <= 0) clearInterval(reserveTimer);
    };
    tick(); reserveTimer = setInterval(tick, 1000);
  };

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const id = form.querySelector('[name="id"]').value;
    const quantity = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10) || 1;
    const items = [{id, quantity}];
    const upsell = form.querySelector('[data-upsell]:checked');
    if (upsell) items.push({id: upsell.value, quantity: 1});
    const label = btn.textContent;
    btn.disabled = true; btn.textContent = '…';
    try {
      const r = await post('/cart/add.js', {items});
      if (!r.ok) throw new Error((await r.json()).description || 'Error');
      await refresh();
      open();
    } catch (err) {
      alert(err.message);
    } finally { btn.disabled = false; btn.textContent = label; }
  });

  /* ---------- variant + pack picker ---------- */
  const initPicker = root => {
    root.querySelectorAll('[data-variant-picker]').forEach(picker => {
      if (picker.dataset.bound) return; picker.dataset.bound = 'true';
      const section = picker.closest('.studio-product');
      const variants = JSON.parse(picker.querySelector('[data-variants]').textContent);
      const form = section.querySelector('form[data-ajax-cart]');
      const selected = () => [1, 2, 3].map(i => picker.querySelector(`input[data-option-index="${i}"]:checked`)?.value ?? null);
      const find = opts => variants.find(v => opts.every((o, i) => o === null || v[`option${i + 1}`] === o));
      const update = () => {
        const opts = selected();
        const v = find(opts);
        // price on each pack card for the currently selected other options
        picker.querySelectorAll('[data-pack-card]').forEach(card => {
          const idx = parseInt(card.dataset.optionIndex, 10) - 1;
          const o = opts.slice(); o[idx] = card.dataset.value;
          const pv = find(o);
          if (!pv) return;
          card.querySelector('[data-pack-price]').textContent = money(pv.price);
          const cmp = card.querySelector('[data-pack-compare]');
          const save = card.querySelector('[data-pack-save]');
          if (pv.compare_at_price && pv.compare_at_price > pv.price) {
            cmp.textContent = money(pv.compare_at_price); cmp.hidden = false;
            save.textContent = save.dataset.label.replace('{{ percent }}', Math.round((1 - pv.price / pv.compare_at_price) * 100));
            save.hidden = false;
          } else { cmp.hidden = true; save.hidden = true; }
          card.classList.toggle('is-selected', opts[idx] === card.dataset.value);
        });
        if (!v) return;
        form.querySelector('[name="id"]').value = v.id;
        section.querySelectorAll('[data-price]').forEach(el => el.textContent = money(v.price));
        section.querySelectorAll('[data-compare]').forEach(el => { el.hidden = !(v.compare_at_price > v.price); el.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; });
        section.querySelectorAll('form[data-ajax-cart] [type="submit"], .sticky button').forEach(b => { b.disabled = !v.available; b.textContent = v.available ? b.dataset.add : b.dataset.soldOut; });
        const url = new URL(location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      };
      picker.addEventListener('change', update);
      update();
    });
    // Shipping timeline is rendered in Liquid; nothing to do here.
  };

  /* ---------- sale countdown + copy code ---------- */
  const initSale = root => {
    root.querySelectorAll('[data-sale-ends]').forEach(el => {
      if (el.dataset.bound) return; el.dataset.bound = 'true';
      const end = Date.parse(el.dataset.saleEnds);
      if (isNaN(end)) { el.hidden = true; return; }
      const tick = () => {
        const left = end - Date.now();
        if (left <= 0) { el.closest('.announce')?.setAttribute('hidden', ''); return; }
        const dd = Math.floor(left / 86400000), hh = Math.floor(left % 86400000 / 3600000), mm = Math.floor(left % 3600000 / 60000), ss = Math.floor(left % 60000 / 1000);
        el.textContent = `${dd}d ${String(hh).padStart(2, '0')}h ${String(mm).padStart(2, '0')}m ${String(ss).padStart(2, '0')}s`;
      };
      tick(); setInterval(tick, 1000);
    });
  };
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-copy-code]');
    if (!b) return;
    const code = b.dataset.copyCode;
    (navigator.clipboard?.writeText(code) || Promise.reject()).catch(() => {}).finally(() => {
      const orig = b.textContent; b.textContent = b.dataset.copied; setTimeout(() => b.textContent = orig, 1600);
      const input = $('[data-drawer-discount] input'); if (input && !input.value) input.value = code;
    });
  });

  const init = (root = document) => { initPicker(root); initSale(root); };
  document.addEventListener('shopify:section:load', e => init(e.target));
  init();
  refresh();
})();
